<div *ngIf="error" class="audit-error">
    {{error}}
</div>
<div class="audit-container">
    <div class="well text-center" *ngIf="!error">

        <div class="customColumn-4"></div>
        <div class="customColumn-4">
            <p class="lead text-left" *ngIf="numberOfVersions">{{ numberOfVersions }} version(s) available</p>
        </div>
        <div class="customColumn-4">
            <button type="button" (click)="auditService.navigateToFormUrl(id)" mat-raised-button color="primary">
                Open in Form
            </button>
        </div>

        <mat-slider *ngIf="numberOfVersions" thumbLabel [max]="max" [min]="min" (input)="onInputChange($event)">
        </mat-slider>
    </div>
    <div class="version-select-container" *ngIf="!error">
        <div class="f-flex f-flex-row f-flex-justify-center f-flex-align-items-center">
            <button type="button" (click)="openVersion(cbxVersionOne)" mat-raised-button
                color="primary">
                Open
            </button>
        </div>
        <sc-document-downloader class="f-flex f-flex-row f-flex-justify-center f-flex-align-items-center"
            matTooltip="Download" matTooltipPosition="above" [fileName]="'version_' + cbxVersionOne + '.json'"
            [toDownload]="toDownloadOne"></sc-document-downloader>
        
        <mat-form-field>
            <mat-select [(ngModel)]="cbxVersionOne" (ngModelChange)="display()">
                <mat-option *ngFor="let version1 of versionIds" [value]="version1.versionId">
                    {{ formatVersionId(version1) }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <div class="f-flex f-flex-row f-flex-justify-center f-flex-align-items-center">
            <mat-checkbox (change)="onCheckboxChange($event)">Sort Fields</mat-checkbox>
        </div>

        <div class="f-flex f-flex-row f-flex-justify-center f-flex-align-items-center">
            <button type="button" (click)="openVersion(cbxVersionTwo)" mat-raised-button color="primary">
                Open
            </button>
        </div>
        <sc-document-downloader class="f-flex f-flex-row f-flex-justify-center f-flex-align-items-center"
            matTooltip="Download" matTooltipPosition="above" [fileName]="'version_' + cbxVersionTwo + '.json'"
            [toDownload]="toDownloadTwo"></sc-document-downloader>
       
        <mat-form-field>
            <mat-select [(ngModel)]="cbxVersionTwo" (ngModelChange)="display()">
                <mat-option *ngFor="let version2 of versionIds" [value]="version2.versionId">
                    {{ formatVersionId(version2) }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="diff-container">
        <div #diffView [ngClass]="{ 'spinner-showing': !isLoading, 'spinner-loading': isLoading }"></div>
    </div>
    <mat-spinner *ngIf="isLoading" class="spin-loader"></mat-spinner>
</div>